import { render, staticRenderFns } from "./BankReceiptsList.vue?vue&type=template&id=32efb56e&scoped=true"
import script from "./BankReceiptsList.vue?vue&type=script&lang=js"
export * from "./BankReceiptsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32efb56e",
  null
  
)

export default component.exports